import SEO from "../../components/seo.jsx"
import { useEffect, useRef, useState, useCallback } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HeroImg from "../../assets/dr-idris-MD.jpeg";
import DoctorPortrait from "../../assets/team/Dr-idris.jpeg";
import Result1Before from "../../assets/gallery/patient-8-before.jpg";
import Result1After from "../../assets/gallery/patient-8-after.jpg";
import Result2Before from "../../assets/gallery/patient-3-before.jpg";
import Result2After from "../../assets/gallery/patient-3-after.jpg";
import Result3Before from "../../assets/gallery/patient-4-before.jpg";
import Result3After from "../../assets/gallery/patient-4-after.jpg";
import BangaloreSkyline from "../../assets/bangalore-loc.PNG";
import ServiceMale from "../../assets/male-ht.png";
import ServiceFemale from "../../assets/female-hair-transplant.png";
import ServiceBeard from "../../assets/beard-transplant.png";
import ServiceEyebrow from "../../assets/eyebrow-ht.png";
import ServiceEyelash from "../../assets/eyelash-hero.png";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };

const PAGE = {

  /* ── HERO ── */
  hero: {
    eyebrow: "Hair Transplant",
    heading: "Hair Transplant Treatment in Bangalore",
    sub: "Natural, long-lasting results from Dr. Idris and the Clinique Internationale Bangalore team, using advanced FUE and FUT techniques.",
  },

  /* ── BREADCRUMB ── */
  breadcrumb: [
    { label: "Home", href: "/" },
    { label: "Hair Transplant in Bangalore", href: null },
  ],

  /* ── INTRO ── */
  intro: {
    eyebrow: "Overview",
    heading: "Hair Transplant Treatment in Bangalore",
    paragraphs: [
      "Hair loss is a common problem that affects both men and women. It can happen for various reasons, such as aging, genetics, hormonal changes, stress, poor diet, and medical conditions. As people age, it's natural for hair to thin and fall out, but for some, hair loss can begin at a young age, which can affect confidence and self-esteem.",
      "A hair transplant is a medical procedure where healthy hair follicles from one part of the body (usually the back or sides of the head) are moved to areas where hair is thinning or missing. The procedure is done under local anaesthesia and involves transplanting natural hair, so the results look very natural — a long-lasting solution for people who want to regain their hair and confidence.",
      "Clinique Internationale offers hair transplant treatment in Bangalore by Dr. Idris, a highly experienced and skilled hair restoration specialist. The clinic uses advanced techniques and state-of-the-art equipment, with personalised care designed to help patients achieve a fuller, thicker head of hair.",
    ],
    stats: [
      { val: "FUE & FUT", sub: "Techniques offered" },
      { val: "1000s", sub: "Patients treated by Dr. Idris" },
      { val: "3", sub: "Practices led — Clinique, GM-Apollo, 32 Smiles" },
      { val: "100%", sub: "Local anaesthesia, natural results" },
    ],
    doctor: {
      name: "Dr. Idris",
      quote:
        "Every patient's hairline is different. My focus at Clinique Internationale Bangalore is a personalised plan and a natural result — I carry out each procedure myself, from consultation through recovery.",
    },
  },

  /* ── HIGHLIGHT CARD (optional dark full-width card) ── */
  highlight: {
    image: DoctorPortrait,
    eyebrow: "Lead Surgeon",
    heading: "Best Hair Transplant Surgeon in Bangalore",
    subheading: "DR. IDRIS",
    role: "Facial Cosmetic & Hair Transplant Surgeon",
    body: [
      "Dr. Idris is a facial cosmetic and hair transplant surgeon in Bangalore with years of experience and a global reputation for excellence. He is the Director of Clinique Internationale, Bangalore Division, and a Consultant Surgeon at GM-Apollo Hospital and the 32 Smiles chain in Bangalore.",
      "Dr. Idris has successfully performed hair transplant surgery for thousands of patients, including hundreds of dentists and doctors from around the world, and is renowned for cutting-edge solutions in hair restoration.",
      "At Clinique Internationale, patients receive the highest level of care throughout the process — Dr. Idris carries out the procedure himself, responds to queries before and after surgery, and is dedicated to natural-looking results for every patient.",
    ],
    tags: ["FUE", "FUT", "GM-Apollo Hospital", "32 Smiles Chain", "Bangalore"],
    statsGrid: [
      { val: "6000s", sub: "Procedures performed" },
      { val: "3", sub: "Affiliated practices" },
      { val: "FUE/FUT", sub: "Techniques mastered" },
      { val: "1-1", sub: "Surgeon-led care" },
    ],
  },

  /* ── COST TABLE (mapped to technique-wise pricing for Bangalore) ── */
  costSection: {
    eyebrow: "Pricing",
    heading: "Hair Transplant Cost in Bangalore",
    intro:
      "Clinique Internationale offers competitive, transparent pricing in Bangalore without compromising on quality of care. Exact cost depends on the number of grafts and technique chosen during your consultation with Dr. Idris.",
    tableHeads: ["Technique", "Grafts Range", "Average Cost"],
    tableRows: [
{
  label: "FUE",
  href: null,
  grafts: "1000–4000",
  cost: "₹30,000 – ₹1,20,000",
  usd: "315–1,263 USD",
},
{
  label: "FUT",
  href: null,
  grafts: "1000–4000",
  cost: "₹30,000 – ₹1,20,000",
  usd: "315–1,263 USD",
},
    ],
    costFactors: [
      { title: "Clinic Reputation", desc: "Clinics with a positive, long-standing reputation often set higher prices than newer or lower-profile centres." },
      { title: "Surgeon's Experience", desc: "Surgeons with extensive experience and specialised expertise may command a higher fee for their services." },
      { title: "Technique Used", desc: "FUE, being a more advanced and less invasive technique, generally tends to be more expensive than FUT." },
      { title: "Number of Grafts", desc: "The total number of grafts required for the transplant directly impacts the overall cost of the procedure." },
    ],
  },

  /* ── TECHNIQUES ── */
  techniques: [
    {
      num: "01",
      title: "Follicular Unit Extraction (FUE)",
      href: null,
      body: "The surgeon uses a micro-punch device to extract individual hair follicles from the donor area, one at a time, then implants them into tiny incisions made in the recipient area. Minimally invasive with no linear scarring.",
      points: [
        "Less invasive than FUT",
        "No linear scar on the back of the head",
        "Ideal for both early and late stages of baldness",
      ],
    },
    {
      num: "02",
      title: "Follicular Unit Transplantation (FUT)",
      href: null,
      body: "A strip of skin is removed from the donor area and dissected into individual follicular units, which are then implanted into incisions made in the recipient area. Well suited to cases needing a larger number of grafts in one session.",
      points: [
        "Efficient for large graft numbers in a single session",
        "Follicles harvested from a permanent hair-bearing region",
      ],
    },
  ],

  /* ── TREATMENTS LIST ── */
  treatments: [
    { num: "01", title: "Male Hair Transplant", href: "/male-hair-transplants.php", desc: "Hair transplant procedures for men, combining precise technique with an understanding of individual hairline and density needs.", image: ServiceMale },
    { num: "02", title: "Female Hair Transplant", href: "/female-hair-transplants.php", desc: "Hair restoration solutions designed around the unique needs and aesthetic preferences of women.", image: ServiceFemale },
    { num: "03", title: "Beard Hair Transplant", href: "/beard-hair-transplants.php", desc: "Precise, natural-looking beard hair transplants that complement facial features.", image: ServiceBeard },
    { num: "04", title: "Eyebrow Hair Transplant", href: "/eyebrow-hair-transplants.php", desc: "Eyebrow restoration and enhancement with natural results that suit facial features.", image: ServiceEyebrow },
    { num: "05", title: "Eyelash Hair Transplant", href: "/eyelash-hair-transplants.php", desc: "Eyelash transplants that integrate seamlessly with existing lashes for a natural look.", image: ServiceEyelash },
  ],

  /* ── PROCEDURE STEPS ── */
  steps: [
    { num: "01", title: "Consultation", desc: "The surgeon evaluates your hair loss condition, determines the best course of treatment, and explains the procedure, expected results, and cost." },
    { num: "02", title: "Preparation", desc: "You'll receive instructions on how to prepare, including avoiding smoking, alcohol, and certain medications that can affect the surgery's outcome." },
    { num: "03", title: "Anaesthesia", desc: "Local anaesthesia is administered to numb both the donor and recipient areas before the procedure begins." },
    { num: "04", title: "Extraction", desc: "In FUE, a micro-punch device extracts individual follicles from the donor area. In FUT, a strip is removed and dissected into individual follicles." },
    { num: "05", title: "Implantation", desc: "Tiny incisions are made in the recipient area and the extracted follicles are carefully implanted into them." },
    { num: "06", title: "Recovery", desc: "Antibiotics and pain medication are prescribed as needed. Strenuous activity and sun exposure should be avoided for a few weeks." },
  ],

  /* ── WHY CHOOSE (mapped from "How to Choose Best Hair Transplant Clinic in Bangalore") ── */
  whyIndia: [
    { title: "Expertise", desc: "Clinique Internationale is synonymous with excellence and expertise in hair transplantation, backed by a dedicated team and a state-of-the-art facility." },
    { title: "Advanced Technology", desc: "The clinic employs state-of-the-art equipment and innovative methods, providing patients with the latest advancements in hair restoration." },
    { title: "Personalised Treatment Plans", desc: "During your initial consultation, the medical team thoroughly assesses your condition and discusses your goals to build a custom treatment plan." },
    { title: "Affordable Excellence", desc: "Quality hair transplantation doesn't have to break the bank — competitive pricing without compromising on quality of care." },
    { title: "Testimonials That Speak Volumes", desc: "Countless satisfied patients have regained their confidence through hair transplantation at Clinique Internationale." },
  ],

  /* ── PROS & CONS ── */
  prosAndCons: {
    pros: [
      { title: "Permanent Solution", desc: "Once transplanted hair takes root, it typically continues to grow naturally for life." },
      { title: "Natural Results", desc: "FUT and FUE techniques achieve natural-looking results by transplanting follicles individually, mimicking natural growth patterns." },
      { title: "Improved Self-Esteem", desc: "Restoring a fuller head of hair significantly boosts self-confidence and quality of life." },
      { title: "Low Maintenance", desc: "Transplanted hair can be washed, cut and styled just like natural hair." },
      { title: "Surgeon-Led Care", desc: "Dr. Idris carries out procedures himself and remains available for queries before and after surgery." },
    ],
    cons: [
      { title: "Upfront Cost", desc: "Procedures can be a significant investment, especially when multiple sessions are needed to achieve the desired result." },
      { title: "Surgical Risks", desc: "Like any surgery, hair transplant carries risks such as infection, bleeding, scarring, or reaction to anaesthesia." },
      { title: "Recovery Care Needed", desc: "Antibiotics, pain medication, and avoidance of strenuous activity and sun exposure are required for a few weeks after surgery." },
      { title: "Temporary Shedding", desc: "Transplanted hair sheds temporarily before re-growing, which can be a distressing phase for some patients." },
      { title: "Time-Consuming", desc: "Procedures can require several hours depending on the extent of hair loss and technique used." },
    ],
  },

  /* ── POST-TRANSPLANT EXPECTATIONS ── */
  expectations: [
    "Dr. Idris responds to any query before and after the procedure, and is dedicated to achieving natural-looking results for each patient.",
    "If you have a particular hairstyle in mind, share it with Dr. Idris during your consultation so the hairline and channels can be planned accordingly.",
    "You will need to take antibiotics and pain medication as prescribed, and avoid strenuous activities and sun exposure for a few weeks.",
    "Get back your lost confidence with natural-looking, long-lasting results from a surgeon-led procedure.",
  ],

  /* ── SUCCESSFUL RESULTS / BEFORE-AFTER ── */
  results: {
    eyebrow: "Success Stories",
    heading: "Successful Results of Hair Transplant in Bangalore",
    sub: "A real transformation from a patient treated by Dr. Idris at Clinique Internationale, Bangalore.",
    cases: [
      {
        beforeImg: Result1Before,
        afterImg: Result1After,
        name: "Patient",
        grafts: "Hair Transplant",
        months: "Result",
        rating: 5,
        review: "Natural, dense results and a hairline that looks completely my own.",
      },
      {
        beforeImg: Result2Before,
        afterImg: Result2After,
        name: "Patient",
        grafts: "Hair Transplant",
        months: "Result",
        rating: 5,
        review: "Natural, dense results and a hairline that looks completely my own.",
      },
      {
        beforeImg: Result3Before,
        afterImg: Result3After,
        name: "Patient",
        grafts: "Hair Transplant",
        months: "Result",
        rating: 5,
        review: "Natural, dense results and a hairline that looks completely my own.",
      },

    ],
  },

  /* ── FAQs ── */
  faqs: [
    {
      q: "Who is the best hair transplant surgeon in Bangalore?",
      a: "Dr. Idris, Director of Clinique Internationale's Bangalore Division and Consultant Surgeon at GM-Apollo Hospital and the 32 Smiles chain, has performed hair transplant surgery in Bangalore for thousands of patients, including doctors and dentists from around the world.",
    },
    {
      q: "What techniques are used for hair transplant in Bangalore?",
      a: "Clinique Internationale Bangalore specialises in Follicular Unit Extraction (FUE) and Follicular Unit Transplantation (FUT) — both minimally invasive methods that deliver natural, long-lasting results.",
    },
    {
      q: "Who is an ideal candidate for a hair transplant?",
      a: "Candidates range from early-stage hair loss (stage 2-3), where a transplant restores a natural hairline or fills thinning areas, to intermediate (stage 3-4) and advanced stages (5-7), where a larger number of grafts — sometimes combined with medical treatment — may be needed.",
    },
    {
      q: "Is the procedure done under general anaesthesia?",
      a: "No. The procedure is performed under local anaesthesia, numbing the donor and recipient areas, so patients remain comfortable and awake throughout.",
    },
    {
      q: "What is the recovery like after a hair transplant?",
      a: "Patients are prescribed antibiotics and pain medication as needed, and are advised to avoid strenuous activities and sun exposure for a few weeks while the transplanted follicles settle in.",
    },
  ],

  /* ── TESTIMONIALS (patient quotes, distinct from the before/after review cards) ── */
  testimonials: {
    eyebrow: "Patient Voices",
    heading: "What Our Patients Say",
    sub: "Real experiences from patients who trusted Dr. Idris and the Clinique Internationale Bangalore team with their hair restoration journey.",
    items: [
      {
        name: "Patient, Bangalore",
        role: "FUE Hair Transplant",
        rating: 5,
        quote: "From the first consultation to the final result, the whole process felt personal and unrushed. Dr. Idris explained every step, and the hairline looks completely natural.",
      },
      {
        name: "Patient, Bangalore",
        role: "FUT Hair Transplant",
        rating: 5,
        quote: "I was nervous about surgery, but the local anaesthesia made it painless and the team kept checking in throughout. Recovery was smoother than I expected.",
      },
      {
        name: "Patient, Bangalore",
        role: "Beard Hair Transplant",
        rating: 5,
        quote: "Density and shape came out exactly the way we planned in the consultation. Genuinely happy with how it blends with my natural beard now.",
      },
    ],
  },

  /* ── YOUTUBE / VIDEO ── */
  video: {
    eyebrow: "Watch & Learn",
    heading: "Take a Tour of a Modern Hair Transplant Clinic",
    youtubeId: "xBaOw1igg4E",
    channelHref: "https://www.youtube.com/@idris686/featured",
    channelLabel: "Visit our YouTube Channel",
  },

  /* ── PATIENT VIDEO TESTIMONIALS (grid of clip-to-play embeds) ── */
  videoTestimonials: {
    eyebrow: "In Their Own Words",
    heading: "Patient Video Testimonials",
    sub: "Hear directly from patients who underwent hair restoration with Dr. Idris at Clinique Internationale, Bangalore.",
    items: [
      { youtubeId: "dQw4w9WgXcQ", name: "Patient, Bangalore", detail: "FUE Hair Transplant · 12 Months" },
      { youtubeId: "dQw4w9WgXcQ", name: "Patient, Bangalore", detail: "FUT Hair Transplant · 10 Months" },
      { youtubeId: "dQw4w9WgXcQ", name: "Patient, Bangalore", detail: "Beard Hair Transplant · 8 Months" },
      { youtubeId: "dQw4w9WgXcQ", name: "Patient, Bangalore", detail: "FUE Hair Transplant · 14 Months" },
    ],
  },

  /* ── CONTACT ── */
  contact: {
    eyebrow: "Get In Touch",
    heading: "Visit or Contact Clinique Internationale, Bangalore",
    sub: "Have a question before booking a consultation? Reach out and our team will get back to you, or message us directly on WhatsApp.",
    details: [
      { label: "Phone", value: "+91 90821 23009", href: "tel:+919082123009" },
      { label: "WhatsApp", value: "Chat with us", href: "https://api.whatsapp.com/send?phone=+919082123009&text=I%27m%20interested%20in%20Hair%20Restoration" },
      { label: "Email", value: "info@hairclinique.in", href: "mailto:info@hairclinique.in" },
      { label: "Location", value: "Clinique Internationale, Bangalore", href: null },
    ],
    formNote: "Fill in your details and our team will call you back to schedule a consultation.",
  },

  /* ── CTA ── */
  cta: {
    eyebrow: "Take the First Step",
    heading: "Begin Your Hair Restoration Journey in Bangalore",
    sub: "Book a personalised consultation with Dr. Idris at Clinique Internationale, Bangalore, and take the first step toward natural, lasting results.",
    primary: { label: "Book Consultation", href: "https://api.whatsapp.com/send?phone=+919082123009&text=I%27m%20interested%20in%20Hair%20Restoration" },
    secondary: { label: "View All Treatments", href: "/about-hair-transplants.php" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false }) {
  return (
    <p
      style={cinzel}
      className={`text-[10px] sm:text-[11px] tracking-[0.34em] uppercase mb-4 flex items-center justify-center gap-3 font-semibold ${light ? "text-[#e9cf8e]" : "text-[#8a6a2a]"}`}
    >
      <span className={`w-8 h-[1.5px] rounded-full ${light ? "bg-gradient-to-r from-transparent to-[#e9cf8e]/80" : "bg-gradient-to-r from-transparent to-[#c9a84c]"}`} />
      {children}
      <span className={`w-8 h-[1.5px] rounded-full ${light ? "bg-gradient-to-l from-transparent to-[#e9cf8e]/80" : "bg-gradient-to-l from-transparent to-[#c9a84c]"}`} />
    </p>
  );
}

function SectionHeading({ children, light = false }) {
  return (
    <h2
      style={cinzel}
      className={`font-black text-[1.45rem] sm:text-[1.9rem] md:text-[2.15rem] text-center uppercase tracking-[0.045em] mb-3 leading-[1.25] ${light ? "text-white" : "text-[#170e04]"}`}
    >
      {children}
    </h2>
  );
}

function HeadingRule({ light = false }) {
  return (
    <div className="flex items-center justify-center gap-2 mb-12 sm:mb-14">
      <span className={`w-1 h-1 rounded-full ${light ? "bg-[#e9cf8e]/60" : "bg-[#c9a84c]/50"}`} />
      <span className={`w-16 h-px ${light ? "bg-gradient-to-r from-transparent via-[#e9cf8e]/70 to-transparent" : "bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent"}`} />
      <span className={`w-1 h-1 rounded-full ${light ? "bg-[#e9cf8e]/60" : "bg-[#c9a84c]/50"}`} />
    </div>
  );
}

function GoldDivider() {
  return <div className="relative w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent">
    <span className="absolute left-1/2 -translate-x-1/2 -top-[3px] w-[7px] h-[7px] rotate-45 bg-[#c9a84c]/40" />
  </div>;
}

function FaqItem({ q, a, dark = false }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-2xl overflow-hidden transition-all duration-500 shadow-[0_18px_40px_-16px_rgba(0,0,0,0.7)] ${
      dark
        ? open
          ? "border-[#c9a84c]/45 bg-gradient-to-br from-[#c9a84c]/[0.09] to-white/[0.02] shadow-[0_22px_50px_-14px_rgba(0,0,0,0.85)]"
          : "border-white/10 bg-white/[0.04] hover:border-[#c9a84c]/30"
        : open
          ? "border-[#c9a84c]/50 bg-gradient-to-br from-[#c9a84c]/[0.06] to-transparent shadow-[0_10px_30px_rgba(90,60,10,0.08)]"
          : "border-[#c9a84c]/15 bg-white hover:border-[#c9a84c]/30"
    }`}>
      <button className="w-full flex items-center justify-between gap-4 px-6 sm:px-7 py-5 sm:py-6 text-left" onClick={() => setOpen((p) => !p)}>
        <span style={cinzel} className={`text-[13px] sm:text-[14px] font-bold tracking-[0.02em] leading-snug ${dark ? "text-white/90" : "text-[#170e04]"}`}>{q}</span>
        <span className={`flex-shrink-0 w-8 h-8 rounded-full border flex items-center justify-center transition-all duration-500 ${open ? "rotate-90 bg-[#c9a84c] border-[#c9a84c] shadow-[0_0_0_5px_rgba(201,168,76,0.12)]" : dark ? "border-[#c9a84c]/45" : "border-[#c9a84c]/40"}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 2v8M2 6h8" stroke={open ? "#170e04" : "#c9a84c"} strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      <div className={`grid transition-all duration-400 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`} style={{ display: "grid" }}>
        <div className="overflow-hidden">
          <p className={`px-6 sm:px-7 pb-6 text-[13.5px] leading-[1.85] ${dark ? "text-white/55" : "text-[#6b5535]"}`}>{a}</p>
        </div>
      </div>
    </div>
  );
}

function StarRating({ count = 5 }) {
  return (
    <div className="flex items-center gap-[3px]">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill={i < count ? "#c9a84c" : "none"}>
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2z"
            stroke="#c9a84c"
            strokeWidth="1.3"
          />
        </svg>
      ))}
    </div>
  );
}

/* ── Lightweight tilt wrapper: tracks pointer position and applies a subtle
   3D rotation via CSS transform, reset with a spring-like transition on
   leave. No animation library — a handful of style updates per hover. ── */
function TiltCard({ children, className = "" }) {
  const ref = useRef(null);
  const [style, setStyle] = useState({});

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setStyle({
      transform: `perspective(700px) rotateX(${(-py * 7).toFixed(2)}deg) rotateY(${(px * 7).toFixed(2)}deg) translateY(-6px)`,
      transition: "transform 0.08s ease-out",
    });
  };
  const onLeave = () => {
    setStyle({ transform: "perspective(700px) rotateX(0deg) rotateY(0deg) translateY(0px)", transition: "transform 0.5s cubic-bezier(0.22,1,0.36,1)" });
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={style}
      className={className}
    >
      {children}
    </div>
  );
}

/* ── Lightbox: full-screen image viewer with prev/next + esc/backdrop close ── */
function ResultLightbox({ items, activeIndex, onClose, onNav }) {
  const isOpen = activeIndex !== null && !!items[activeIndex];

  useEffect(() => {
    if (!isOpen) return; // don't touch scroll/listeners unless actually open

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose, onNav]);

  if (!isOpen) return null;
  const item = items[activeIndex];

  return (
    <div
      className="fixed inset-0 z-[999] bg-[#0b0705]/96 backdrop-blur-sm flex items-center justify-center px-4 sm:px-8 animate-[fadeIn_0.25s_ease-out]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      {/* close button */}
      <button
        onClick={onClose}
        aria-label="Close"
        className="absolute top-5 right-5 sm:top-7 sm:right-7 w-10 h-10 rounded-full border border-[#c9a84c]/30 flex items-center justify-center text-[#c9a84c] hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-colors z-10"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 2l12 12M14 2L2 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>

      {/* prev */}
      <button
        onClick={(e) => { e.stopPropagation(); onNav(-1); }}
        aria-label="Previous"
        className="absolute left-3 sm:left-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-[#c9a84c]/30 flex items-center justify-center text-[#c9a84c] hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-colors z-10"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 2L4 8l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* next */}
      <button
        onClick={(e) => { e.stopPropagation(); onNav(1); }}
        aria-label="Next"
        className="absolute right-3 sm:right-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-[#c9a84c]/30 flex items-center justify-center text-[#c9a84c] hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-colors z-10"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 2l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* content */}
      <div
        className="relative max-w-3xl w-full flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative w-full rounded-2xl overflow-hidden border border-[#c9a84c]/30 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
          <img
            src={item.src}
            alt={`${item.name} ${item.label}`}
            className="w-full max-h-[70vh] object-contain bg-[#0b0705]"
          />
          <span
            style={cinzel}
            className={`absolute top-4 left-4 text-[10px] tracking-[0.15em] uppercase px-3 py-1.5 rounded font-bold ${
              item.label === "Before" ? "bg-[#0b0705]/85 text-white/85" : "bg-[#c9a84c] text-[#170e04]"
            }`}
          >
            {item.label}
          </span>
        </div>
        <div className="mt-5 text-center">
          <p style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-white">{item.name}</p>
          <p className="text-[11.5px] text-[#e9cf8e]/80 mt-1.5 tracking-wide">{item.grafts} · {item.months}</p>
        </div>
      </div>
    </div>
  );
}

function ResultCard({ r, onImageClick }) {
  return (
    <div className="group bg-white border border-[#c9a84c]/18 rounded-[1.4rem] overflow-hidden relative hover:-translate-y-2 hover:border-[#c9a84c]/40 hover:shadow-[0_20px_46px_rgba(90,60,10,0.14)] transition-all duration-500">
      <span className="absolute top-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent z-10" />
      <div className="grid grid-cols-2 relative">
        <button
          type="button"
          onClick={() => onImageClick(0)}
          className="relative cursor-zoom-in overflow-hidden"
          aria-label={`View ${r.name} before photo full size`}
        >
          <img src={r.beforeImg} alt={`${r.name} before hair transplant`} className="w-full h-44 sm:h-56 object-cover transition-transform duration-700 group-hover:scale-[1.06]" />
          <div className="absolute inset-0 bg-[#0b0705]/0 hover:bg-[#0b0705]/15 transition-colors" />
          <span style={cinzel} className="absolute bottom-2.5 left-2.5 text-[9px] tracking-[0.18em] uppercase bg-[#0b0705]/80 text-white/80 px-2.5 py-1 rounded">
            Before
          </span>
        </button>
        <button
          type="button"
          onClick={() => onImageClick(1)}
          className="relative cursor-zoom-in overflow-hidden"
          aria-label={`View ${r.name} after photo full size`}
        >
          <img src={r.afterImg} alt={`${r.name} after hair transplant`} className="w-full h-44 sm:h-56 object-cover transition-transform duration-700 group-hover:scale-[1.06]" />
          <div className="absolute inset-0 bg-[#0b0705]/0 hover:bg-[#0b0705]/15 transition-colors" />
          <span style={cinzel} className="absolute bottom-2.5 left-2.5 text-[9px] tracking-[0.18em] uppercase bg-[#c9a84c] text-[#170e04] px-2.5 py-1 rounded font-bold">
            After
          </span>
        </button>
        {/* diagonal divider accent between before/after */}
        <span className="pointer-events-none absolute inset-y-0 left-1/2 -translate-x-1/2 w-px bg-gradient-to-b from-transparent via-[#c9a84c]/70 to-transparent" />
      </div>
      <div className="p-6 sm:p-7">
        <div className="flex items-center justify-between mb-3 gap-2">
          <p style={cinzel} className="text-[12.5px] font-bold tracking-[0.05em] uppercase text-[#170e04]">{r.name}</p>
          <StarRating count={r.rating} />
        </div>
        <div className="flex flex-wrap gap-2 mb-4">
          <span style={cinzel} className="text-[9.5px] tracking-[0.1em] uppercase text-[#8a6a2a] border border-[#c9a84c]/25 bg-[#c9a84c]/[0.04] rounded-full px-3 py-1">{r.grafts}</span>
          <span style={cinzel} className="text-[9.5px] tracking-[0.1em] uppercase text-[#8a6a2a] border border-[#c9a84c]/25 bg-[#c9a84c]/[0.04] rounded-full px-3 py-1">{r.months}</span>
        </div>
        <p className="text-[13.5px] italic leading-[1.8] text-[#6b5535]">"{r.review}"</p>
      </div>
    </div>
  );
}

/* ============================================================
   PAGE COMPONENT — DO NOT EDIT BELOW THIS LINE
============================================================ */
export default function ServicePage() {
  const pageRef       = useRef(null);
  const heroEyeRef    = useRef(null);
  const heroHeadRef   = useRef(null);
  const heroSubRef    = useRef(null);
  const sectionRefs   = useRef([]);
  const addSection    = (el) => el && !sectionRefs.current.includes(el) && sectionRefs.current.push(el);
  const servicesTrackRef = useRef(null);
  const scrollServices = (dir) => {
    const el = servicesTrackRef.current;
    if (!el) return;
    const card = el.querySelector("[data-service-card]");
    const step = card ? card.getBoundingClientRect().width + 24 : el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step, behavior: "smooth" });
  };
  const whyCardRefs = useRef([]);
  const addWhyCard = (el) => el && !whyCardRefs.current.includes(el) && whyCardRefs.current.push(el);

  /* flatten all before/after images into a single ordered list for the lightbox,
     so prev/next can move seamlessly across cards */
  const lightboxItems = PAGE.results.cases.flatMap((r) => [
    { src: r.beforeImg, label: "Before", name: r.name, grafts: r.grafts, months: r.months },
    { src: r.afterImg, label: "After", name: r.name, grafts: r.grafts, months: r.months },
  ]);
  const [activeIndex, setActiveIndex] = useState(null);

  const openLightbox = (caseIdx, imgIdx) => setActiveIndex(caseIdx * 2 + imgIdx);
  const closeLightbox = useCallback(() => setActiveIndex(null), []);
  const navLightbox = useCallback(
    (dir) => setActiveIndex((prev) => (prev === null ? null : (prev + dir + lightboxItems.length) % lightboxItems.length)),
    [lightboxItems.length]
  );

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current,  { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 28 }, { opacity: 1, y: 0, duration: 0.8, ease, delay: 0.12 });
      gsap.fromTo(heroSubRef.current,  { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.22 });

      sectionRefs.current.forEach((el) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 42 },
          { opacity: 1, y: 0, duration: 0.85, ease,
            scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      });

      // Why Choose Us — individual card stagger + scale-in, layered on top of the
      // section-level fade above for a livelier, more "premium" entrance.
      if (whyCardRefs.current.length) {
        gsap.fromTo(whyCardRefs.current,
          { opacity: 0, y: 30, scale: 0.96 },
          { opacity: 1, y: 0, scale: 1, duration: 0.65, ease, stagger: 0.12,
            scrollTrigger: { trigger: whyCardRefs.current[0], start: "top 90%", toggleActions: "play none none reverse" } }
        );
      }
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "max-w-6xl mx-auto px-5 sm:px-8 lg:px-12";
  const sec  = "py-20 sm:py-24 md:py-8";

  return (
    <>
    <SEO
  title="Best Hair Transplant Clinic in Bangalore | Dr. Idris - Clinique Internationale"
  description="Clinique Internationale Bangalore offers advanced Sapphire FUE hair transplant & hair restoration, led by Dr. Idris. Natural results, expert care — book your consultation."
  url="https://bangalore.hairclinique.in/"
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />
      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes shimmerSweep { 0% { background-position: 200% 0 } 100% { background-position: -200% 0 } }
        .clq-shine { background-size: 200% 100%; animation: shimmerSweep 6s linear infinite; }
      `}</style>

<div ref={pageRef} className="relative w-full bg-[#f6f0e4] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative h-[180px] xs:h-[200px] sm:h-[380px] md:h-[420px] mt-0 lg:mt-10  flex items-center overflow-hidden">
    <img
      className="absolute inset-0 w-full h-full object-cover object-[center_20%] scale-[1.03]"
      src={HeroImg}
      alt={PAGE.hero.heading}
    />
    <div className="absolute inset-0" />
    <div className="absolute inset-0" />
    <div
      className="absolute inset-0 opacity-30 pointer-events-none mix-blend-overlay"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.05'/%3E%3C/svg%3E\")" }}
    />
    {/* thin gold frame line, luxury boutique cue */}
    <div className="absolute inset-4 sm:inset-6 border border-[#c9a84c]/25 rounded-sm pointer-events-none hidden sm:block" />
  </div>


        {/* ── BREADCRUMB ── */}
        <div className="bg-[#0b0705] border-b border-[#c9a84c]/12">
          <div className={`${wrap} py-3.5 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-[0.2em] uppercase text-[#c9a84c]/55 hover:text-[#e9cf8e] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-[0.2em] uppercase text-[#e9cf8e]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            INTRO text + stats card + doctor quote
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection} className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start">
            {/* LEFT */}
            <div>
              <Eyebrow>{PAGE.intro.eyebrow}</Eyebrow>
              <h2 style={cinzel} className="font-black text-[1.6rem] sm:text-[1.95rem] md:text-[2.2rem] tracking-[0.03em] uppercase text-[#170e04] leading-[1.2] mb-7 text-center md:text-left">
                {PAGE.intro.heading}
              </h2>
              {PAGE.intro.paragraphs.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.95] text-[#3a2e1e] mb-5 font-light">{p}</p>
              ))}
            </div>
            {/* RIGHT */}
            <div className="flex flex-col gap-6">
                            {/* Bangalore city visual — grounds the practice in its city */}
              <div className="group relative overflow-hidden rounded-[1.4rem] border border-[#c9a84c]/22 shadow-[0_16px_40px_rgba(90,60,10,0.1)]">
                <img
                  src={BangaloreSkyline}
                  alt="Bangalore city skyline"
                  className="w-full h-[600px] sm:h-[500px] object-contain transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b0705]/85 via-[#0b0705]/15 to-transparent" />
                <span className="absolute top-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
                <div className="absolute bottom-5 left-6 right-6 flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#c9a84c]/90 flex items-center justify-center flex-shrink-0">
                    <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
                      <path d="M4 21V9l6-4 6 4v12" stroke="#170e04" strokeWidth="1.8" strokeLinejoin="round" fill="none"/>
                      <path d="M14 21V13h4v8" stroke="#170e04" strokeWidth="1.8" strokeLinejoin="round" fill="none"/>
                    </svg>
                  </div>
                  <div>
                    <p style={cinzel} className="text-[12px] font-bold tracking-[0.06em] text-white">Bangalore</p>
                    <p className="text-[11px] text-[#e9cf8e]/85 italic">Clinique Internationale, Bangalore Division</p>
                  </div>
                </div>
              </div>
              {/* stats */}
              <div className="relative overflow-hidden bg-[#0b0705] border border-[#c9a84c]/25 rounded-[1.4rem] p-8 shadow-[0_20px_50px_rgba(20,12,2,0.18)]">
                <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/60 to-transparent" />
                <span className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#c9a84c]/10 blur-3xl" />
                <p style={cinzel} className="text-[10px] tracking-[0.26em] uppercase text-[#e9cf8e]/70 mb-6 font-semibold">At a Glance</p>
                <div className="grid grid-cols-2 gap-6">
                  {PAGE.intro.stats.map((s) => (
                    <div key={s.val}>
                      <div style={cinzel} className="font-black text-[1.7rem] leading-none mb-1.5 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                      <div className="text-[11.5px] text-white/50 leading-snug font-light">{s.sub}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            HIGHLIGHT CARD surgeon / key info
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0b0705] py-20 sm:py-24 md:py-8 relative">
          <div className="absolute top-0 left-1/4 w-72 h-72 rounded-full bg-[#c9a84c]/[0.06] blur-[100px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection} className="relative overflow-hidden border border-[#c9a84c]/25 rounded-[1.6rem] p-8 sm:p-11 md:p-14 shadow-[0_25px_60px_rgba(0,0,0,0.35)]"
              style={{ background: "linear-gradient(135deg,rgba(201,168,76,0.09),rgba(201,168,76,0.015))" }}>
              <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/60 to-transparent" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-9 md:gap-14 items-start">
                <div>
                  <Eyebrow light>{PAGE.highlight.eyebrow}</Eyebrow>
                  <h2 style={cinzel} className="font-black text-[1.45rem] sm:text-[1.8rem] md:text-[2.1rem] text-white uppercase tracking-[0.04em] leading-[1.2] mb-2">{PAGE.highlight.heading}</h2>
                  <p style={cinzel} className="text-[12.5px] text-[#e9cf8e]/90 tracking-[0.1em] mb-1">{PAGE.highlight.subheading}</p>
                  <p className="text-[12.5px] text-white/45 italic mb-6 font-light">{PAGE.highlight.role}</p>
                  {PAGE.highlight.body.map((p, i) => (
                    <p key={i} className="text-[13.5px] leading-[1.9] text-white/60 mb-3.5 font-light">{p}</p>
                  ))}
                  <div className="flex flex-wrap gap-2 mt-5">
                    {PAGE.highlight.tags.map((t) => (
                      <span key={t} style={cinzel} className="text-[9.5px] tracking-[0.14em] uppercase text-[#e9cf8e]/90 border border-[#c9a84c]/30 rounded-full px-3.5 py-1.5">{t}</span>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col gap-6">
                  {/* doctor portrait */}
                  <div className="relative rounded-[1.4rem] overflow-hidden border border-[#c9a84c]/30 shadow-[0_20px_45px_rgba(0,0,0,0.35)]">
                    <img
                      src={PAGE.highlight.image}
                      alt={PAGE.highlight.subheading}
                      className="w-full h-auto object-contain object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0b0705]/90 via-[#0b0705]/10 to-transparent" />
                    <div className="absolute bottom-5 left-5 right-5">
                      <p style={cinzel} className="text-[13.5px] font-bold tracking-[0.06em] text-white">{PAGE.highlight.subheading}</p>
                      <p className="text-[11px] text-[#e9cf8e]/90 italic">{PAGE.highlight.role}</p>
                    </div>
                  </div>
                  {/* stats grid */}
                  <div className="grid grid-cols-2 gap-4">
                    {PAGE.highlight.statsGrid.map((s) => (
                      <div key={s.val} className="bg-white/[0.045] border border-[#c9a84c]/14 rounded-2xl p-5 text-center hover:bg-[#c9a84c]/[0.09] hover:border-[#c9a84c]/30 transition-colors duration-300">
                        <div style={cinzel} className="font-black text-[1rem] leading-none mb-1.5 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                        <div className="text-[11px] text-white/45 leading-snug font-light">{s.sub}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            COST TABLE
        ══════════════════════════════════════ */}
<div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>{PAGE.costSection.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.costSection.heading}</SectionHeading>
            <HeadingRule />
            <p className="text-[14.5px] leading-[1.95] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10 font-light">{PAGE.costSection.intro}</p>

            {/* ── Desktop/tablet: standard table ── */}
            <div className="hidden sm:block overflow-x-auto rounded-[1.4rem] border border-[#c9a84c]/22 shadow-[0_10px_36px_rgba(90,60,10,0.09)] mb-12">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0b0705]">
                    {PAGE.costSection.tableHeads.map((h) => (
                      <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.14em] uppercase text-[#e9cf8e] px-6 py-5 font-bold">{h}</th>
                    ))}
                    <th style={cinzel} className="text-left text-[11px] tracking-[0.14em] uppercase text-[#e9cf8e] px-6 py-5 font-bold">USD Range</th>
                  </tr>
                </thead>
                <tbody>
                  {PAGE.costSection.tableRows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white" : "bg-[#f6f0e4]"} hover:bg-[#c9a84c]/[0.06] transition-colors`}>
                      <td className="px-6 py-5">
                        {r.href
                          ? <a href={r.href} style={cinzel} className="text-[12.5px] font-bold text-[#8a6a2a] hover:text-[#c9a84c] tracking-wide transition-colors">{r.label}</a>
                          : <span style={cinzel} className="text-[12.5px] font-bold text-[#8a6a2a] tracking-wide">{r.label}</span>}
                      </td>
                      <td className="px-6 py-5 text-[13.5px] text-[#3a2e1e]">{r.grafts}</td>
                      <td className="px-6 py-5 text-[13.5px] font-semibold text-[#170e04]">{r.cost}</td>
                      <td className="px-6 py-5 text-[12.5px] text-[#6b5535]">{r.usd}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ── Mobile: stacked vertical cards, one per technique ── */}
            <div className="sm:hidden flex flex-col gap-4 mb-12">
              {PAGE.costSection.tableRows.map((r, i) => (
                <div key={i} className="rounded-2xl border border-[#c9a84c]/22 shadow-[0_10px_30px_rgba(90,60,10,0.08)] overflow-hidden">
                  <div className="bg-[#0b0705] px-5 py-3.5">
                    {r.href
                      ? <a href={r.href} style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-[#e9cf8e]">{r.label}</a>
                      : <span style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-[#e9cf8e]">{r.label}</span>}
                  </div>
                  <div className={`${i % 2 === 0 ? "bg-white" : "bg-[#f6f0e4]"} divide-y divide-[#c9a84c]/12`}>
                    <div className="flex items-center justify-between px-5 py-3">
                      <span style={cinzel} className="text-[10px] tracking-[0.12em] uppercase text-[#8a6a2a]">{PAGE.costSection.tableHeads[1]}</span>
                      <span className="text-[13px] text-[#3a2e1e] font-medium">{r.grafts}</span>
                    </div>
                    <div className="flex items-center justify-between px-5 py-3">
                      <span style={cinzel} className="text-[10px] tracking-[0.12em] uppercase text-[#8a6a2a]">{PAGE.costSection.tableHeads[2]}</span>
                      <span className="text-[13.5px] text-[#170e04] font-semibold">{r.cost}</span>
                    </div>
                    <div className="flex items-center justify-between px-5 py-3">
                      <span style={cinzel} className="text-[10px] tracking-[0.12em] uppercase text-[#8a6a2a]">USD Range</span>
                      <span className="text-[12.5px] text-[#6b5535]">{r.usd}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {PAGE.costSection.costFactors.map((f, i) => (
                <div key={i} className="bg-white border border-[#c9a84c]/20 rounded-2xl p-6 sm:p-7 relative overflow-hidden hover:-translate-y-2 hover:border-[#c9a84c]/40 hover:shadow-[0_16px_38px_rgba(90,60,10,0.12)] transition-all duration-400">
                  <span className="absolute top-0 left-5 right-5 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                  <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#170e04] mb-3">{f.title}</div>
                  <p className="text-[13px] leading-[1.8] text-[#6b5535] font-light">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>  

        {/* ══════════════════════════════════════
            TECHNIQUES
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0b0705] py-20 sm:py-24 md:py-8 relative overflow-hidden">
          <div className="absolute top-0 right-1/4 w-80 h-80 rounded-full bg-[#c9a84c]/[0.06] blur-[110px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection}>
              <Eyebrow light>Methods</Eyebrow>
              <SectionHeading light>Techniques of Hair Restoration</SectionHeading>
              <HeadingRule light />
              <div className="flex flex-col gap-7">
                {PAGE.techniques.map((t) => (
                  <div key={t.num} className="bg-gradient-to-br from-[#c9a84c]/[0.08] to-[#c9a84c]/[0.015] border border-[#c9a84c]/18 rounded-[1.4rem] p-7 sm:p-9 relative overflow-hidden hover:shadow-[0_14px_38px_rgba(0,0,0,0.35)] hover:border-[#c9a84c]/35 transition-all duration-400">
                    <span className="absolute top-0 left-5 right-5 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                    <div className="flex gap-6 items-start flex-col sm:flex-row">
                      <span style={cinzel} className="font-black text-[2.6rem] leading-none bg-gradient-to-br from-[#c9a84c]/60 to-[#c9a84c]/15 bg-clip-text text-transparent select-none flex-shrink-0">{t.num}</span>
                      <div className="flex-1">
                        {t.href
                          ? <a href={t.href} style={cinzel} className="text-[14.5px] font-bold tracking-[0.05em] uppercase text-white mb-3.5 hover:text-[#e9cf8e] transition-colors inline-block">{t.title}</a>
                          : <div style={cinzel} className="text-[14.5px] font-bold tracking-[0.05em] uppercase text-white mb-3.5">{t.title}</div>}
                        <p className="text-[13.5px] leading-[1.9] text-white/55 mb-4 font-light">{t.body}</p>
                        {t.points.length > 0 && (
                          <ul className="flex flex-col gap-2">
                            {t.points.map((pt, i) => (
                              <li key={i} className="flex items-start gap-3 text-[13px] text-white/55">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] flex-shrink-0 mt-1.5" />
                                {pt}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            TREATMENTS LIST
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <div className="flex items-end justify-between gap-4 mb-2 flex-wrap">
              <div className="flex-1 min-w-[240px]">
                <Eyebrow>Our Services</Eyebrow>
                <SectionHeading>Hair Transplant Treatments at Clinique Internationale</SectionHeading>
              </div>
              {/* carousel controls — hidden on touch-first small screens where swipe is natural */}
              <div className="hidden sm:flex items-center gap-3 mb-10">
                <button type="button" onClick={() => scrollServices(-1)} aria-label="Scroll services left"
                  className="w-11 h-11 rounded-full border border-[#c9a84c]/35 flex items-center justify-center text-[#8a6a2a] hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-colors">
                  <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M10 2L4 8l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
                <button type="button" onClick={() => scrollServices(1)} aria-label="Scroll services right"
                  className="w-11 h-11 rounded-full border border-[#c9a84c]/35 flex items-center justify-center text-[#8a6a2a] hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-colors">
                  <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M6 2l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
              </div>
            </div>
            <HeadingRule />
            <div
              ref={servicesTrackRef}
              className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 -mx-1 px-1 scroll-smooth [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
            >
              {PAGE.treatments.map((t) => (
                <a key={t.num} href={t.href} data-service-card
                  className="group snap-start flex-shrink-0 w-[78%] xs:w-[62%] sm:w-[46%] md:w-[31%] bg-white border border-[#c9a84c]/20 rounded-[1.4rem] overflow-hidden relative hover:-translate-y-2 hover:border-[#c9a84c]/40 hover:shadow-[0_20px_46px_rgba(90,60,10,0.14)] transition-all duration-400 block">
                  <div className="relative h-44 sm:h-48 overflow-hidden">
                    <img src={t.image} alt={t.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.1]" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0b0705]/70 via-[#0b0705]/5 to-transparent" />
                    <span style={cinzel} className="absolute top-3 left-3 font-black text-[1.15rem] leading-none text-white/90 drop-shadow">{t.num}</span>
                  </div>
                  <div className="p-6">
                    <div style={cinzel} className="text-[13px] font-bold tracking-[0.05em] uppercase text-[#170e04] group-hover:text-[#8a6a2a] transition-colors mb-2.5">{t.title}</div>
                    <p className="text-[13px] leading-[1.8] text-[#6b5535] font-light mb-4">{t.desc}</p>
                    <div className="flex items-center gap-1.5">
                      <span style={cinzel} className="text-[10px] tracking-[0.2em] uppercase text-[#c9a84c] font-bold">Learn More</span>
                      <span className="text-[#c9a84c] text-xs transition-transform group-hover:translate-x-1 inline-block">→</span>
                    </div>
                  </div>
                  <span className="absolute top-0 left-5 right-5 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                </a>
              ))}
            </div>
            <p className="sm:hidden text-center text-[11px] tracking-[0.15em] uppercase text-[#8a6a2a] mt-3">← Swipe to explore →</p>
          </div>
        </div>


        {/* ══════════════════════════════════════
            PROCEDURE STEPS dark band
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0b0705] py-20 sm:py-24 md:py-8 relative">
          <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-[#c9a84c]/[0.05] blur-[110px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection}>
              <Eyebrow light>How It Works</Eyebrow>
              <SectionHeading light>Procedure of Hair Transplant in Bangalore</SectionHeading>
              <HeadingRule light />
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {PAGE.steps.map((s) => (
                  <div key={s.num} className="relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.08] to-[#c9a84c]/[0.015] border border-[#c9a84c]/18 rounded-2xl p-7 sm:p-8 hover:border-[#c9a84c]/35 hover:-translate-y-1.5 transition-all duration-400">
                    <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                    <span style={cinzel} className="font-black text-[2.3rem] leading-none bg-gradient-to-br from-[#c9a84c]/45 to-[#c9a84c]/10 bg-clip-text text-transparent select-none block mb-4">{s.num}</span>
                    <div style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-white/90 mb-3">{s.title}</div>
                    <p className="text-[13px] leading-[1.85] text-white/55 font-light">{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            WHY CHOOSE
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>Why Choose Us</Eyebrow>
            <SectionHeading>How to Choose the Best Hair Transplant Clinic in Bangalore?</SectionHeading>
            <HeadingRule />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" style={{ perspective: "1000px" }}>
              {PAGE.whyIndia.map((w, i) => (
                <TiltCard key={i} className="group">
                  <div ref={addWhyCard} className="bg-white border border-[#c9a84c]/20 rounded-2xl p-7 relative overflow-hidden hover:border-[#c9a84c]/45 hover:shadow-[0_20px_44px_rgba(90,60,10,0.14)] transition-[border-color,box-shadow] duration-400">
                    <span className="absolute top-0 left-5 right-5 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                    <span className="pointer-events-none absolute -bottom-10 -right-10 w-28 h-28 rounded-full bg-[#c9a84c]/[0.07] blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#c9a84c]/12 to-[#c9a84c]/[0.02] border border-[#c9a84c]/25 flex items-center justify-center mb-5 transition-transform duration-500 group-hover:rotate-[18deg] group-hover:scale-110">
                      <span style={cinzel} className="text-[12.5px] font-black text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                    <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#170e04] mb-2.5">{w.title}</div>
                    <p className="text-[13px] leading-[1.8] text-[#6b5535] font-light">{w.desc}</p>
                    <span className="absolute bottom-0 left-0 h-[2.5px] bg-gradient-to-r from-[#c9a84c] to-[#e9cf8e] w-0 group-hover:w-full transition-all duration-500 ease-out rounded-full" />
                  </div>
                </TiltCard>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            PROS & CONS
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0b0705] py-20 sm:py-24 md:py-8 relative overflow-hidden">
          <div className="absolute top-0 left-1/4 w-80 h-80 rounded-full bg-[#c9a84c]/[0.06] blur-[110px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection}>
              <Eyebrow light>Considerations</Eyebrow>
              <SectionHeading light>Advantages &amp; Disadvantages</SectionHeading>
              <HeadingRule light />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-7 md:gap-9">
                {/* PROS */}
                <div>
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-9 h-9 rounded-full bg-emerald-400/10 border border-emerald-400/30 flex items-center justify-center">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-6" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span style={cinzel} className="text-[13px] font-bold uppercase tracking-[0.07em] text-white">Advantages</span>
                  </div>
                  <div className="flex flex-col gap-3.5">
                    {PAGE.prosAndCons.pros.map((p, i) => (
                      <div key={i} className="bg-white/[0.045] border border-emerald-400/15 rounded-2xl p-5 flex gap-3.5 items-start shadow-[0_20px_46px_-14px_rgba(0,0,0,0.75)] hover:border-emerald-400/35 hover:shadow-[0_28px_60px_-12px_rgba(0,0,0,0.85)] hover:-translate-y-1 transition-all duration-350">
                        <span className="w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0 mt-1.5" />
                        <div>
                          <div style={cinzel} className="text-[12px] font-bold tracking-wide uppercase text-white/90 mb-1.5">{p.title}</div>
                          <p className="text-[13px] leading-[1.75] text-white/55 font-light">{p.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* CONS */}
                <div>
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-9 h-9 rounded-full bg-amber-400/10 border border-amber-400/30 flex items-center justify-center">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 3v5M7 10v1" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round"/></svg>
                    </div>
                    <span style={cinzel} className="text-[13px] font-bold uppercase tracking-[0.07em] text-white">Disadvantages</span>
                  </div>
                  <div className="flex flex-col gap-3.5">
                    {PAGE.prosAndCons.cons.map((c, i) => (
                      <div key={i} className="bg-white/[0.045] border border-amber-400/15 rounded-2xl p-5 flex gap-3.5 items-start shadow-[0_20px_46px_-14px_rgba(0,0,0,0.75)] hover:border-amber-400/35 hover:shadow-[0_28px_60px_-12px_rgba(0,0,0,0.85)] hover:-translate-y-1 transition-all duration-350">
                        <span className="w-2 h-2 rounded-full bg-amber-400 flex-shrink-0 mt-1.5" />
                        <div>
                          <div style={cinzel} className="text-[12px] font-bold tracking-wide uppercase text-white/90 mb-1.5">{c.title}</div>
                          <p className="text-[13px] leading-[1.75] text-white/55 font-light">{c.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            POST-TRANSPLANT EXPECTATIONS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>After the Procedure</Eyebrow>
            <SectionHeading>What to Expect After Hair Transplant at Clinique Internationale?</SectionHeading>
            <HeadingRule />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {PAGE.expectations.map((e, i) => (
                <div key={i} className="bg-white border border-[#c9a84c]/20 rounded-2xl p-7 flex gap-4 items-start relative overflow-hidden hover:border-[#c9a84c]/35 hover:shadow-[0_12px_30px_rgba(90,60,10,0.08)] transition-all duration-400">
                  <span className="absolute top-0 left-5 right-5 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                  <div className="w-9 h-9 flex-shrink-0 rounded-full bg-gradient-to-br from-[#c9a84c]/18 to-[#c9a84c]/5 border border-[#c9a84c]/25 flex items-center justify-center">
                    <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <p className="text-[13.5px] leading-[1.85] text-[#6b5535] font-light">{e}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            FAQ
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0b0705] py-20 sm:py-24 md:py-8 relative overflow-hidden">
          <div className="absolute bottom-0 left-1/3 w-72 h-72 rounded-full bg-[#c9a84c]/[0.06] blur-[110px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection}>
              <Eyebrow light>Common Questions</Eyebrow>
              <SectionHeading light>Frequently Asked Questions</SectionHeading>
              <HeadingRule light />
              <div className="max-w-3xl mx-auto flex flex-col gap-4">
                {PAGE.faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} dark />)}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SUCCESSFUL RESULTS / BEFORE-AFTER
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf7f0] py-20 sm:py-24 md:py-8">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow>{PAGE.results.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.results.heading}</SectionHeading>
              <HeadingRule />
              <p className="text-[14.5px] leading-[1.95] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-12 font-light">{PAGE.results.sub}</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
                {PAGE.results.cases.map((r, i) => (
                  <ResultCard key={i} r={r} onImageClick={(imgIdx) => openLightbox(i, imgIdx)} />
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            TESTIMONIALS
        ══════════════════════════════════════ */}
        <div className="bg-[#0b0705] py-20 sm:py-24 md:py-8 relative overflow-hidden">
          <div className="absolute top-0 right-1/4 w-80 h-80 rounded-full bg-[#c9a84c]/[0.06] blur-[110px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection}>
              <Eyebrow light>{PAGE.testimonials.eyebrow}</Eyebrow>
              <SectionHeading light>{PAGE.testimonials.heading}</SectionHeading>
              <HeadingRule light />
              <p className="text-[14.5px] leading-[1.95] text-white/55 max-w-3xl mx-auto text-center mb-12 font-light">{PAGE.testimonials.sub}</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {PAGE.testimonials.items.map((t, i) => (
                  <div key={i} className="relative bg-white/[0.045] border border-white/10 rounded-[1.4rem] p-7 sm:p-8 overflow-hidden shadow-[0_22px_50px_-14px_rgba(0,0,0,0.75)] hover:-translate-y-2 hover:border-[#c9a84c]/35 hover:shadow-[0_30px_65px_-12px_rgba(0,0,0,0.85)] transition-all duration-400">
                    <span className="absolute top-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                    <span style={cinzel} className="block text-[2.6rem] leading-none text-[#c9a84c]/25 mb-2 select-none">“</span>
                    <StarRating count={t.rating} />
                    <p className="text-[13.5px] italic leading-[1.9] text-white/60 mt-4 mb-6">"{t.quote}"</p>
                    <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                      <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#c9a84c]/25 to-[#c9a84c]/5 border border-[#c9a84c]/30 flex items-center justify-center flex-shrink-0">
                        <svg viewBox="0 0 24 24" fill="none" width="15" height="15">
                          <circle cx="12" cy="8" r="4" stroke="#c9a84c" strokeWidth="1.8" fill="none"/>
                          <path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#c9a84c" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
                        </svg>
                      </div>
                      <div>
                        <p style={cinzel} className="text-[11.5px] font-bold tracking-[0.04em] text-white/90">{t.name}</p>
                        <p className="text-[11px] text-[#e9cf8e]/80">{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            YOUTUBE / VIDEO
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-white py-20 sm:py-24 md:py-8 relative overflow-hidden">
          <div className="absolute top-0 left-1/3 w-96 h-96 rounded-full bg-[#c9a84c]/[0.06] blur-[120px] pointer-events-none" />
          <div className={`${wrap} relative`}>
            <div ref={addSection}>
              <Eyebrow>{PAGE.video.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.video.heading}</SectionHeading>
              <HeadingRule />
              <p className="text-[14px] leading-[1.9] text-[#6b5535] max-w-2xl mx-auto text-center mb-10 font-light">{PAGE.video.sub}</p>
              <div className="max-w-3xl mx-auto">
                <div className="relative rounded-[1.4rem] overflow-hidden border border-[#c9a84c]/25 shadow-[0_25px_60px_rgba(90,60,10,0.15)]" style={{ aspectRatio: "16 / 9" }}>
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${PAGE.video.youtubeId}`}
                    title={PAGE.video.heading}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="text-center mt-7">
                  <a href={PAGE.video.channelHref} target="_blank" rel="noopener noreferrer"
                    style={cinzel}
                    className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.16em] uppercase text-[#8a6a2a] border border-[#c9a84c]/35 rounded-full px-6 py-3 hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-all">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#8a6a2a"><path d="M21.6 7.2s-.2-1.5-.8-2.2c-.8-.8-1.7-.8-2.1-.9C15.9 4 12 4 12 4h0s-3.9 0-6.7.1c-.4 0-1.3.1-2.1.9-.6.7-.8 2.2-.8 2.2S2.2 9 2.2 10.7v1.6C2.2 14 2.4 15.8 2.4 15.8s.2 1.5.8 2.2c.8.8 1.9.8 2.4.9 1.7.2 7.4.2 7.4.2s3.9 0 6.7-.1c.4 0 1.3-.1 2.1-.9.6-.7.8-2.2.8-2.2s.2-1.8.2-3.5v-1.6c0-1.7-.2-3.5-.2-3.5zM9.9 14.6V8.9l5.4 2.9-5.4 2.8z"/></svg>
                    {PAGE.video.channelLabel}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            CONTACT
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>{PAGE.contact.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.contact.heading}</SectionHeading>
            <HeadingRule />
            <p className="text-[14.5px] leading-[1.95] text-[#3a2e1e] max-w-2xl mx-auto text-center mb-12 font-light">{PAGE.contact.sub}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 max-w-4xl mx-auto items-stretch">
              {/* details */}
              <div className="flex flex-col gap-4">
                {PAGE.contact.details.map((d, i) => {
                  const Wrapper = d.href ? "a" : "div";
                  const wrapperProps = d.href ? { href: d.href, target: d.href.startsWith("http") ? "_blank" : undefined, rel: "noopener noreferrer" } : {};
                  return (
                    <Wrapper key={i} {...wrapperProps}
                      className="group bg-white border border-[#c9a84c]/20 rounded-2xl p-5 flex items-center gap-4 relative overflow-hidden hover:border-[#c9a84c]/40 hover:shadow-[0_12px_30px_rgba(90,60,10,0.08)] transition-all duration-300">
                      <span className="absolute top-0 left-5 right-5 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                      <div className="w-11 h-11 flex-shrink-0 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/5 border border-[#c9a84c]/25 flex items-center justify-center">
                        <span style={cinzel} className="text-[10px] font-black text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                      </div>
                      <div>
                        <p style={cinzel} className="text-[10px] tracking-[0.14em] uppercase text-[#8a6a2a] mb-0.5">{d.label}</p>
                        <p className={`text-[13.5px] font-medium text-[#170e04] ${d.href ? "group-hover:text-[#8a6a2a]" : ""} transition-colors`}>{d.value}</p>
                      </div>
                    </Wrapper>
                  );
                })}
              </div>

              {/* simple enquiry form (UI only — wire up to your backend/email service) */}
              <form
                className="bg-white border border-[#c9a84c]/20 rounded-2xl p-7 flex flex-col gap-4 relative overflow-hidden"
                onSubmit={(e) => e.preventDefault()}
              >
                <span className="absolute top-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                <p className="text-[12.5px] text-[#6b5535] leading-[1.7] mb-1 font-light">{PAGE.contact.formNote}</p>
                <input type="text" name="name" placeholder="Full Name" required
                  className="w-full rounded-xl border border-[#c9a84c]/25 bg-[#faf7f0] px-4 py-3 text-[13.5px] text-[#170e04] placeholder:text-[#a08a63] focus:outline-none focus:border-[#c9a84c]/60 focus:bg-white transition-colors" />
                <input type="tel" name="phone" placeholder="Phone Number" required
                  className="w-full rounded-xl border border-[#c9a84c]/25 bg-[#faf7f0] px-4 py-3 text-[13.5px] text-[#170e04] placeholder:text-[#a08a63] focus:outline-none focus:border-[#c9a84c]/60 focus:bg-white transition-colors" />
                <textarea name="message" placeholder="Tell us about your requirement (optional)" rows={3}
                  className="w-full rounded-xl border border-[#c9a84c]/25 bg-[#faf7f0] px-4 py-3 text-[13.5px] text-[#170e04] placeholder:text-[#a08a63] focus:outline-none focus:border-[#c9a84c]/60 focus:bg-white transition-colors resize-none" />
                <button type="submit"
                  style={{ ...cinzel, backgroundImage: "linear-gradient(110deg,#c9943a,#ffe9a0,#c9943a,#ffe9a0)" }}
                  className="clq-shine text-[11px] font-bold tracking-[0.18em] uppercase px-6 py-3.5 rounded-lg text-[#170e04] shadow-[0_10px_28px_rgba(201,168,76,0.3)] hover:-translate-y-0.5 hover:shadow-[0_14px_34px_rgba(201,168,76,0.4)] transition-all mt-1">
                  Request a Callback
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            CTA
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection} className="max-w-xl mx-auto text-center relative">
            <span className="absolute -top-6 left-1/2 -translate-x-1/2 w-px h-6 bg-gradient-to-b from-transparent to-[#c9a84c]/50" />
            <Eyebrow>{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.35rem] sm:text-[1.75rem] md:text-[2rem] text-[#170e04] uppercase tracking-[0.06em] mb-4 leading-[1.25]">{PAGE.cta.heading}</h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.85] mb-9 font-light">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href} target="_blank" rel="noopener noreferrer"
                style={{ ...cinzel, backgroundImage: "linear-gradient(110deg,#c9943a,#ffe9a0,#c9943a,#ffe9a0)" }}
                className="clq-shine text-[11px] font-bold tracking-[0.18em] uppercase px-9 py-4 rounded-lg text-[#170e04] shadow-[0_10px_28px_rgba(201,168,76,0.3)] hover:-translate-y-0.5 hover:shadow-[0_14px_34px_rgba(201,168,76,0.4)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href}
                style={cinzel}
                className="text-[11px] font-bold tracking-[0.18em] uppercase px-9 py-[15px] rounded-lg bg-transparent border border-[#170e04]/30 text-[#170e04] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#8a6a2a] hover:bg-[#c9a84c]/[0.04] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

      </div>

      {/* ── LIGHTBOX (portal-less, rendered at page root so it overlays everything) ── */}
      <ResultLightbox
        items={lightboxItems}
        activeIndex={activeIndex}
        onClose={closeLightbox}
        onNav={navLightbox}
      />
    </>
  );
}